import { ILocalStorageService } from '@/app/Data/Adapters/ILocalStorageService';
import { environment } from '@/environments/environment';
import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanDeactivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class GuestGuard implements CanLoad, CanActivate {
  constructor(
    @Inject(ILocalStorageService) private localStorage: ILocalStorageService,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const isLoggedIn =
      !!this.localStorage.getItem('yib_tk');

    // Redirect signup page to external site in production
    if (environment.production && state.url.includes('/auth/signup')) {
      window.location.href = 'https://www.yobi.com/sign-up';
      return false;
    }

    if(state.url.includes('/auth/reset-password')){
      return true;
    }
    
    if (isLoggedIn) {
      this.router.navigate(['/main']);
      // return true;
    }
    return !isLoggedIn;
    
    // Redirect to external onboarding site when not logged in
    // window.location.href = 'https://onboarding-dev1.yib.io/login';
    // return false;
  }
  // fro lazy loading modules
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const isLoggedIn =
      !!this.localStorage.getItem('yib_tk');
    
    if (isLoggedIn) {
      this.router.navigate(['/main']);
      return true;
    }
    
    // Redirect to external onboarding site when not logged in
    window.location.href = 'https://onboarding-dev1.yib.io/login';
    return false;
  }
}
